import * as types from './constants';

// Edit Account Phone
export const editAccountPhoneRequest = data => (
  { type: types.EDIT_ACCOUNT_PHONE_REQUEST, payload: data }
);

export const editAccountPhoneDone = data => (
  { type: types.EDIT_ACCOUNT_PHONE_DONE, payload: data }
);

export const editAccountPhoneFailed = errors => (
  { type: types.EDIT_ACCOUNT_PHONE_FAILED, payload: errors }
);

export const editAccountPhoneReset = () => (
  { type: types.EDIT_ACCOUNT_PHONE_RESET }
);